import React from 'react';
import PropTypes from "prop-types";
import {useFormik} from "formik";

import {ResponsiveDialog} from "../../../../../components/ResponsiveDialog";

import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField/TextField";
import {useBookingFinanceUpdate} from "../../../query";
import {useFeedbackTools} from "../../../../../components/FeedbackTools";
import extraChargeValidationSchema from "./validator";


const FormExtraCharge = ({bookingFinance, extraCharge, onClose}) => {
    const {showSuccessNotification, showErrorNotification} = useFeedbackTools();
    const bookingFinanceUpdate = useBookingFinanceUpdate({bookingId: bookingFinance.bookingId});
    const newRecord = !extraCharge?.id;

    const formik = useFormik({
        initialValues: {
            descriptionOther: extraCharge?.descriptionOther ?? '',
            price: extraCharge?.price ?? null,
        },
        validationSchema: extraChargeValidationSchema,
        onSubmit: async (values) => {
            try {
                const data = newRecord ? values : {...values, id: extraCharge.id};
                await bookingFinanceUpdate.mutateAsync({data: {extraChargesAttributes: [data]}});
                onClose();
                showSuccessNotification('Extra creato con successo');
            } catch (e) {
                showErrorNotification(e);
            }
        }
    });

    const submitIsEnabled = !Object.keys(formik.errors).some(x => formik.touched[x]);

    return (
        <ResponsiveDialog title={newRecord ? "Nuovo extra" : "Modifica extra"}
                          isOpen={true}
                          maxWidth="md"
                          scroll="paper"
                          isLoading={bookingFinanceUpdate.isLoading}
                          showApply={true}
                          applyLabel="Salva"
                          enableApply={submitIsEnabled}
                          onApply={formik.handleSubmit}
                          closeLabel="Cancella"
                          onClose={onClose}>
            <Grid container spacing={3} sx={{pt: 1}}>
                <Grid item xs={12} md={6}>
                    <TextField fullWidth
                               name="descriptionOther"
                               label="Descrizione"
                               value={formik.values.descriptionOther}
                               onChange={formik.handleChange}
                               error={formik.touched.descriptionOther && Boolean(formik.errors.descriptionOther)}
                               helperText={formik.touched.descriptionOther && formik.errors.descriptionOther}>
                    </TextField>
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField type="number"
                               label="Prezzo"
                               fullWidth
                               name="price"
                               value={formik.values.price}
                               onChange={formik.handleChange}
                               error={formik.touched.price && Boolean(formik.errors.price)}
                               helperText={formik.touched.price && formik.errors.price}
                               InputProps={{
                                   startAdornment: <InputAdornment position="end">€</InputAdornment>,
                               }}/>
                </Grid>
            </Grid>
        </ResponsiveDialog>
    );
};

FormExtraCharge.propTypes = {
    bookingFinance: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    extraCharge: PropTypes.object,
}

export default FormExtraCharge;